<template>
  <div class="main-wrapper">
    <import-task ref="importTask">
      <template slot="header">
        <search-box class="search-box">
          <el-form :inline="true" size="mini" label-width="60px">
            <el-form-item label="平台">
              <el-select
                v-model="form.platName"
                filterable
                @change="handleSearch"
              >
                <el-option
                  v-for="item in ['唯品会', '京东']"
                  :label="item"
                  :key="item"
                  :value="item"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="模板ID" v-if="isShowVip">
              <el-input
                v-model="form.templateId"
                @keyup.native.enter="handleSearch"
              />
            </el-form-item>
          </el-form>
          <template v-slot:right>
            <el-button type="primary" size="small" @click="handleSearch">搜索</el-button>
            <el-button class="orange-btn" size="mini" @click="handleReset">重置</el-button>
          </template>
        </search-box>
      </template>
      <template slot="main-header">
        <el-button type="primary" size="mini" @click="showExport"
          >批量导入
        </el-button>
      </template>
    </import-task>
    <el-dialog
      :title="titleName"
      width="60%;"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
    >
      <div slot="footer" class="dialog-footer">
        <el-form
          :model="requestParam"
          :rules="rules"
          ref="requestParam"
          size="small"
          label-width="80px"
        >
          <el-row>
            <el-col :span="24" align="left">
              <el-form-item label="平台">
                <el-select
                  v-model="requestParam.platName"
                  filterable
                  clearable
                  disabled
                >
                  <el-option
                    v-for="item in ['唯品会', '京东']"
                    :label="item"
                    :key="item"
                    :value="item"
                  ></el-option>
                </el-select>
              </el-form-item> 
              <el-form-item label="业务类型" v-if="!isShowVip" prop="businessType">
                <el-radio-group v-model="requestParam.businessType">
                  <el-radio label="入仓自营">入仓自营</el-radio>
                  <el-radio label="厂家直送">厂家直送</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="模板ID" v-if="isShowVip" prop="templateId">
                <el-input
                  v-model.trim="requestParam.templateId"
                />
              </el-form-item>
              <!-- <el-form-item label="品类" v-if="!isShowVip" prop="category">
                <el-input
                  v-model.trim="requestParam.category"
                  @keyup.native.enter="handleSearch"
                />
              </el-form-item> -->
              <el-form-item label="附件" prop="goodsCode">
                <el-upload
                  class="upload-demo"
                  ref="upload"
                  accept=".xls,.xlsx,.xls.ttt,.xlsx.ttt"
                  :limit="1"
                  action=""
                  :http-request="httpRequest"
                  :on-remove="handleRemove"
                  :headers="headers"
                  :file-list="fileList"
                  :on-success="handleSuccess"
                  :before-upload="beforeUpload"
                >
                  <el-button slot="trigger" size="small" type="primary"
                    >选取文件</el-button
                  >
                  <el-button
                    style="margin-left: 10px"
                    v-loading.fullscreen.lock="fjLoading"
                    element-loading-text="数据导入中"
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(0, 0, 0, 0.8)"
                    size="small"
                    type="success"
                    @click="checkFormValid"
                    >上传
                  </el-button>
                  <div slot="tip" class="el-upload__tip">
                    只能上传xls/xlsx文件，且只能上传一个
                  </div>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-button @click="cancel" size="medium">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getToken } from "@/utils/auth";
import moment from "moment";
import pagePathMixin from '@/utils/page-path-mixin'
export default {
  mixins: [pagePathMixin],
  data() {
    return {
      form: {
        platName: "唯品会",
        endDate: "",
        endDateStr: "",
        reportName: "",
        appCode: "ec-pc-new",
      },
      dialogFormVisible: false,
      titleName: "上传",
      requestParam: {},
      headers: {
        Authorization: getToken(),
      },
      fileList: [],
      rules: {
        businessType: [
          { required: true, message: "请选择业务类型", trigger: "change" },
        ],
        category: [
          { required: true, message: "请输入品类", trigger: "blur" },
        ],
        templateId: [
          { required: true, message: "请输入模板ID", trigger: "blur" },
        ],
      },
      fjLoading: false,
      // reportName: 'importProductLabel'
    };
  },
  computed: {
    reportName() {
      return this.form.platName == "唯品会"
        ? "configAreaWeiPinHuiImport"
        : "configAreaJingDongImport";
    },
    isShowVip() {
      return this.form.platName == "唯品会";
    },
  },
  methods: {
    handleSearch() {
      this.form.reportName = this.reportName;
      this.form.endDate =
        this.form.endDateStr == null || this.form.endDateStr == ""
          ? this.form.endDateStr
          : this.form.endDateStr.substr(0, 10) + " 23:59:59";
      
      if(!this.isShowVip) {
        // this.form.filterDTO = [{
        //   fieldName: 'businessType',
        //   fieldValue: this.form.businessType || ''
        // }]
      }else {
        this.form.filterDTO = [{
          fieldName: 'templateId',
          fieldValue: this.form.templateId || ''
        }]
      }
      this.$refs["importTask"].page.pageNum = 1
      this.$refs["importTask"].init(this.form);
    },
    handleReset() {
      this.form = {
        reportName: 'configAreaWeiPinHuiImport',
        appCode: "ec-pc-new",
        platName: '唯品会'
      };
      this.handleSearch();
    },
    showExport() {
      this.fileList = [];
      this.$set(this.requestParam, "platName", this.form.platName);
      this.dialogFormVisible = true;
      this.titleName = "上传";
    },
    cancel() {
      this.dialogFormVisible = false;
      this.requestParam = {}
      this.$refs.requestParam.resetFields()
    },
    handleRemove(file, fileList) {
      this.fileList = [];
      console.log(file, fileList);
    },
    httpRequest(file) {},
    handleSuccess(res, file) {
      if (res.code === 200) {
        this.$message.success(res.message);
      } else {
        this.$message.error(res.message);
      }
      this.cancel();
      this.handleSearch();
    },
    // 验证
    beforeUpload(file) {
      // .xls,.xlsx,.xls.ttt,.xlsx.ttt
      let pattern = file.name.substring(file.name.lastIndexOf(".") + 1);
      if (
        ["xls", "xlsx", "xls.ttt", "xlsx.ttt"].indexOf(
          pattern.toLowerCase()
        ) === -1
      ) {
        this.$message.error("请上传后缀名为.xls,.xlsx的附件！");
        return false;
      }
      this.fileList = [];
      this.fileList.push(file);
    },
    checkFormValid(file) {
      this.$refs["requestParam"].validate((valid) => {
        if (valid) {
          this.submitUpload(file);
        } else {
          this.$message.error("参数校验失败！");
        }
      });
    },
    submitUpload(file) {
      if (!this.fileList || this.fileList.length === 0) {
        this.$message.error("请先上传Excel附件");
        return;
      }
      this.fjLoading = true;

      let taskDTO = null;
      let fields = [
        {
          columnName: "模板ID",
          columnValue: this.requestParam.templateId,
          fieldName: "templateId",
          fieldValue: this.requestParam.templateId,
          relation: "templateId",
        },
      ];
      if(!this.isShowVip) {
        fields = [
          {
          columnName: "",
          columnValue: "",
          fieldName: "fileName",
          fieldValue: this.fileList[0].name.substring(0, this.fileList[0].name.lastIndexOf(".")),
          relation: "fileName",
          },
          {
            columnName: "业务类型",
            columnValue: this.requestParam.businessType,
            fieldName: "businessType",
            fieldValue: this.requestParam.businessType,
            relation: "businessType",
          },
        ]
      }
      taskDTO = {
        reportName: this.form.reportName,
        appCode: "ec-pc-new",
        paramMap: fields,
      };

      this.$q.common
        .uploadFile({
          data: {
            file: this.fileList[0],
            taskDTO: JSON.stringify(taskDTO),
          },
        })
        .then((res) => {
          if (res.success) {
            this.$message.success("数据导入中，请稍后");
          } else {
            this.$message.error(res.message);
          }
          this.fjLoading = false;
          this.cancel();
          this.handleSearch();
        });
      // this.$refs.upload.submit();
    },
  },
  mounted() {
    this.handleSearch();
  },
};
</script>

<style lang="stylus" scoped>
.main-wrapper
  height calc(100vh - 65px)
.root
  padding 5px
>>> .el-header
  height: 39px !important
  margin-bottom: 5px
  padding 0
</style>
